export const DocumentTypesEnum = {
    EMPLOYEE_TRANSFERS_FEE_INVOICE: 1,
    EMPLOYEE_ADVANCE_TRANSFER_REQUEST: 2,
    COMPANY_SUBSCRIPTION_FEE_INVOICE: 4
};
